// src/components/HeaderSection.jsx
import React, { useState } from "react";
import { motion } from "framer-motion";

export default function HeaderSection({ onSearch }) {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  return (
    <section className="w-full bg-black/30 backdrop-blur-sm py-16 px-6 md:px-16 flex flex-col md:flex-row items-center justify-between gap-8">
      {/* Left: Heading & Subheading */}
      <motion.div
        className="flex flex-col gap-4 md:w-2/3"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.7 }}
      >
        <h1 className="text-white italic text-5xl md:text-4xl font-bold">
          Training Tips · Nutrition Guides · Fitness Strategies
        </h1>

        <p className="text-neonTurquoise italic text-xl md:text-2xl">
          Explore clear methods that support training, nutrition, and long-term
          performance.
        </p>
      </motion.div>

      {/* Right: Search */}
      <motion.form
        onSubmit={handleSearch}
        className="flex gap-2 md:w-1/3"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.7 }}
      >
        <input
          type="text"
          placeholder="Search blogs..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-3 rounded-lg bg-gray-900 text-white border border-gray-700 focus:ring-2 focus:ring-neonTurquoise outline-none"
        />
        <button
          type="submit"
          className="px-4 py-3 bg-neonTurquoise text-black font-bold rounded-lg hover:bg-neonTurquoise/80 transition"
        >
          Search
        </button>
      </motion.form>
    </section>
  );
}
